import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId", "use"];
import { generatePath, useLocation } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DUPLICATE_PLAYLIST_URL_FRAGMENT, PLAYLIST_URL_FRAGMENT } from '../../../constants/Navigation';
import UsageTracker from '../../../utils/UsageTracker';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const DuplicatePlaylistButton = _ref => {
  let {
      playlistId,
      use
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const location = useLocation();
  const newLocation = Object.assign({}, location, {
    pathname: `${generatePath(PLAYLIST_URL_FRAGMENT, {
      playlistId
    })}${DUPLICATE_PLAYLIST_URL_FRAGMENT}`,
    state: {
      from: location
    }
  });
  const handleClick = () => {
    UsageTracker.track('playlistInteraction', {
      action: 'duplicate-playlist-click',
      playlistId
    });
  };
  return /*#__PURE__*/_jsx(RouterButton, Object.assign({}, props, {
    onClick: handleClick,
    to: newLocation,
    use: use,
    children: /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      textAlign: "start",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.duplicatePlaylist"
      })
    })
  }));
};